import { cn } from '../lib/utils';
import type { Mode } from '../lib/types';

interface ModeToggleProps {
  mode: Mode;
  onModeChange: (mode: Mode) => void;
  buyPercent: number;
  onBuyPercentChange: (percent: number) => void;
}

export function ModeToggle({
  mode,
  onModeChange,
  buyPercent,
  onBuyPercentChange,
}: ModeToggleProps) {
  const presets = [50, 60, 70, 80];

  return (
    <div className="w-48 space-y-3">
      {/* MD3 segmented button — selected segment gets Secondary Container
          fill, matching the spec (no per-mode hue-coding; the old cyan/green
          glow scheme has no MD3 equivalent). */}
      <div className="flex rounded-full bg-muted p-1">
        <button
          onClick={() => onModeChange('sell')}
          className={cn(
            'flex-1 rounded-full px-4 py-2 text-sm font-medium transition-all duration-200 ease-emphasized-decelerate',
            mode === 'sell'
              ? 'bg-secondary text-secondary-foreground shadow-sm'
              : 'text-muted-foreground hover:text-foreground'
          )}
        >
          Sell Price
        </button>
        <button
          onClick={() => onModeChange('buy')}
          className={cn(
            'flex-1 rounded-full px-4 py-2 text-sm font-medium transition-all duration-200 ease-emphasized-decelerate',
            mode === 'buy'
              ? 'bg-secondary text-secondary-foreground shadow-sm'
              : 'text-muted-foreground hover:text-foreground'
          )}
        >
          Buy Offer
        </button>
      </div>

      {/* Buy percent presets (only show in buy mode) */}
      {mode === 'buy' && (
        <div className="flex items-center gap-2">
          <span className="text-xs text-muted-foreground">Offer:</span>
          <div className="flex gap-1">
            {presets.map((percent) => (
              <button
                key={percent}
                onClick={() => onBuyPercentChange(percent)}
                className={cn(
                  'rounded-full px-2 py-1 text-xs font-medium transition-all duration-200 ease-emphasized-decelerate',
                  buyPercent === percent
                    ? 'bg-secondary text-secondary-foreground'
                    : 'bg-muted text-muted-foreground hover:text-foreground'
                )}
              >
                {percent}%
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
